export const configDeriv = {
    appid: 23556,
    lang: "PT",
    uri: "https://oauth.binary.com/oauth2/authorize?app_id",
    endpoint: "ws.binaryws.com"
}